<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col content-header-col d-flex">
          <h1 class="m-0">{{ title }}</h1>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentHeader",
  props: {
    title: String,
  },
};
</script>

<style scoped>
@media (max-width: 365px) {
  .content-header-col {
    flex-direction: column;
  }
  .content-header-col > .btn {
    width: 100%;
    margin: 0!important;
  }
  .content-header-col > h1 {
    margin-bottom: 1rem!important;
  }
}
</style>
